/* eslint-disable react/prop-types */
import QuoteFormComponent from "./quote-form";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as helper from "@/common/helper";
import * as appSlice from "@/app/app.slice";
import { useHistory } from "react-router-dom";
import { LINKS } from "@/static-texts/links";

const PREVENTIVE = "QuoteRequest";

function QuoteForm({
  offer,
  correlatedAnnouncements,
  services,
  currentAnnouncement,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [isSendRequestEnabled, setSendRequestEnabled] = useState(false);
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [vatNumber, setVatNumber] = useState("");

  const [isPrivacySelected, setPrivacySelected] = useState(false);

  var status = useSelector(appSlice.selectStatus);

  useEffect(() => {
    setSendRequestEnabled(
      helper.isValidEmail(email) &&
        name?.length &&
        surname?.length &&
        businessName?.length &&
        phone?.length &&
        isPrivacySelected
    );
  }, [businessName, email, name, phone, surname, isPrivacySelected]);

  useEffect(() => {
    if (status === appSlice.Status.ASKED) {
      dispatch(appSlice.setStatus({ status: appSlice.Status.IDLE }));
      history.push(LINKS.REQUEST_CONFIRMED);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const announcements = getAnnouncementsAsNamesList(
    offer?.correlatedAnnouncements,
    correlatedAnnouncements,
    currentAnnouncement
  );
  const correlatedServices = getervicesAsNamesList(
    offer?.correlatedServices,
    services
  );

  const handleSendRequestClick = () => {
    const request = {
      mail: email,
      name: name,
      surname: surname,
      businessName: businessName,
      requestFrom: PREVENTIVE,
      phone: phone,
      services: correlatedServices,
      vatNumber: vatNumber,
      announcements: announcements,
    };
    dispatch(appSlice.sendEmailRequest(request));
  };

  const handleEmailChange = (e) => {
    if (e.target.value) {
      setEmail(e.target.value);
    } else {
      setEmail("");
    }
  };

  const handleNameChange = (e) => {
    if (e.target.value) {
      setName(e.target.value);
    } else {
      setName("");
    }
  };

  const handleSurnameChange = (e) => {
    if (e.target.value) {
      setSurname(e.target.value);
    } else {
      setSurname("");
    }
  };

  const handlePhoneChange = (e) => {
    if (e.target.value) {
      setPhone(e.target.value);
    } else {
      setPhone("");
    }
  };

  const handleBuisinessNameChange = (e) => {
    if (e.target.value) {
      setBusinessName(e.target.value);
    } else {
      setBusinessName("");
    }
  };

  const handleVatNumberChane = (e) => {
    if (e.target.value) {
      setVatNumber(e.target.value);
    } else {
      setVatNumber("");
    }
  };

  const handlePrivacySelect = (isActive) => {
    setPrivacySelected(isActive);
  };

  return (
    <QuoteFormComponent
      announcements={announcements}
      services={correlatedServices}
      name={name}
      surname={surname}
      businessName={businessName}
      phone={phone}
      email={email}
      onEmailChange={handleEmailChange}
      onNameChane={handleNameChange}
      onSurnameChange={handleSurnameChange}
      onPhoneChange={handlePhoneChange}
      onBuisinessNameChange={handleBuisinessNameChange}
      onSendReuqestClick={handleSendRequestClick}
      isSendRequestEnabled={isSendRequestEnabled}
      isPravacySelcted={isPrivacySelected}
      onPrivacySelect={handlePrivacySelect}
      vatNumber={vatNumber}
      onVatNumberChane={handleVatNumberChane}
      status={status}
    />
  );
}

function getAnnouncementsAsNamesList(
  offer,
  correlatedAnnouncements,
  currentAnnouncement
) {
  return offer.map((id) => {
    if (id === currentAnnouncement.id) {
      return currentAnnouncement.title;
    } else {
      return correlatedAnnouncements.find(
        (announcement) => announcement.id === id
      )?.title;
    }
  });
}

function getervicesAsNamesList(offer, services) {
  return offer.map((id) => {
    return services.find((service) => service.id === id).title;
  });
}
export default QuoteForm;
